<template>
  <div>
    <div
      class="mb15 capitalize cl-mine-shaft available-status available-setting_rwd"
      :class="{ 'center': align === 'center', 'left': align === 'left', 'right': align === 'right' }"
      v-if="categoryProps  === config.rootcategories.drukowanie"
    >
      {{ $t("available") }}:
      <span class="available-dots">
        <span class="available-dot" :class="{ 'active': getProductQty >= 1 }"></span>
        <span class="available-dot" :class="{ 'active': getProductQty > 10 }"></span>
        <span class="available-dot" :class="{ 'active': getProductQty > 20 }"></span>
        <span class="available-dot" :class="{ 'active': getProductQty > 30 }"></span>
      </span>
    </div>
    <div
      class="mb15 capitalize cl-mine-shaft available-status"
      :class="{ 'center': align === 'center', 'left': align === 'left', 'right': align === 'right' }"
      v-if="categoryProps === config.rootcategories.biuro"
    >
      {{ showAvailability }}
    </div>
  </div>
</template>

<script>
import config from 'config'

export default {
  data () {
    return {
      config
    }
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    categoryProps: {
      type: String,
      default: config.rootcategories.drukowanie
    },
    align: {
      type: String,
      required: false,
      default: 'center'
    }
  },

  computed: {
    getProductQty () {
      const { stock } = this.product;
      return stock && stock[0] ? (stock[0].is_in_stock ? stock[0].qty : stock[0].qty) : this.product.qty;
    },
    showAvailability () {
      return this.getProductQty === 0 ? 'Niedostępny' : 'Dostępny'
    }
  }
};
</script>

<style lang="scss" scoped>
  @import '~theme/css/variables/colors';
  @import '~theme/css/helpers/functions/color';
  $color-strong-cyan: color(strong-cyan);
  $color-gainsboro: color(gainsboro);
  $color-dark-blue: color(dark-blue);

  .available-status {
    text-transform: capitalize;
    display: flex;
    align-items: center;
    font-size: 14px;

    &.center {
      justify-content: center;
    }
    &.left {
      justify-content: flex-start;
    }
    &.right {
      justify-content: flex-end;
    }

    @media (max-width: 767px) {
      flex-wrap: wrap;
    }
  }

  .available-dots {
    display: inline-block;
    margin-left: 6px;
    height: 16px;
    margin-top: 2px;

    .available-dot {
      width: 10px;
      height: 10px;
      display: inline-block;
      box-sizing: border-box;
      border-radius: 14px;
      background: $gray;
      margin-right: 6px;

      &.active {
        background: $green;
      }
    }
  }

  .available-setting_rwd {
    @media(max-width: 1200px){
      flex-direction: column;
    }
  }
</style>
